// classes/HeavyClass.js
export const HeavyClass = {
  id: 'heavy',
  name: 'Heavy',
  description: 'Armored weapons specialist with devastating firepower and area control',
  icon: '🛡️',
  recruitCost: 0,
  
  baseStats: {
    health: 120,
    maxHealth: 120,
    aim: 65,
    mobility: 50,
    defense: 70,
    willpower: 80,
    critChance: 10
  },

  skills: [
    // TIER 1
    {
      id: 'heavy_armor',
      name: 'Heavy Armor',
      tier: 1,
      xpRequired: 0,
      description: 'Reinforced plating. +15 Defense',
      effect: { defense: 15 }
    },
    {
      id: 'bullet_swarm',
      name: 'Bullet Swarm',
      tier: 1,
      xpRequired: 25,
      description: 'Firing weapon does not end turn',
      effect: { fireNoTurnEnd: true }
    },

    // TIER 2
    {
      id: 'shredder',
      name: 'Shredder',
      tier: 2,
      xpRequired: 60,
      description: 'Attacks permanently reduce enemy defense by 25',
      effect: { shredderAmount: 25 }
    },
    {
      id: 'resilience',
      name: 'Resilience',
      tier: 2,
      xpRequired: 60,
      description: 'Built tough. +20 Health, +15 Willpower',
      effect: { health: 20, maxHealth: 20, willpower: 15 }
    },

    // TIER 3
    {
      id: 'heat_ammo',
      name: 'HEAT Ammo',
      tier: 3,
      xpRequired: 125,
      description: 'Armor-piercing rounds. +40% damage against armored targets',
      effect: { armorPiercingBonus: 40 }
    },
    {
      id: 'suppression',
      name: 'Suppression Master',
      tier: 3,
      xpRequired: 125,
      description: 'Can suppress multiple enemies at once in an area',
      effect: { multiSuppression: true, suppressionRadius: 5 }
    },

    // TIER 4
    {
      id: 'hardened',
      name: 'Hardened',
      tier: 4,
      xpRequired: 200,
      description: 'Damage reduction from all sources. -20% incoming damage',
      effect: { damageReduction: 20 }
    },
    {
      id: 'area_suppression',
      name: 'Area Suppression',
      tier: 4,
      xpRequired: 200,
      description: 'Suppressed enemies have -50 aim instead of -30',
      effect: { suppressionAimPenalty: -50 }
    },

    // TIER 5
    {
      id: 'demolitions_expert',
      name: 'Demolitions Expert',
      tier: 5,
      xpRequired: 300,
      description: 'Explosive damage increased by 50%',
      effect: { explosiveDamageBonus: 50 }
    },
    {
      id: 'immovable',
      name: 'Immovable',
      tier: 5,
      xpRequired: 300,
      description: 'Cannot be moved, knocked back, or repositioned by enemies',
      effect: { movementImmune: true }
    },

    // TIER 6
    {
      id: 'devastation',
      name: 'Devastation',
      tier: 6,
      xpRequired: 450,
      description: 'Massive firepower. +50% weapon damage',
      effect: { weaponDamageBonus: 50 }
    },
    {
      id: 'collateral_damage',
      name: 'Collateral Damage',
      tier: 6,
      xpRequired: 450,
      description: 'Attacks have 30% chance to hit adjacent enemies for half damage',
      effect: { splashDamageChance: 30, splashDamagePercent: 50 }
    },

    // TIER 7
    {
      id: 'fortress',
      name: 'Fortress',
      tier: 7,
      xpRequired: 625,
      description: 'When stationary, gain +40 defense and +30% damage',
      effect: { stationaryBonus: { defense: 40, damageBonus: 30 } }
    },
    {
      id: 'unstoppable',
      name: 'Unstoppable',
      tier: 7,
      xpRequired: 625,
      description: 'Immune to critical hits and status effects',
      effect: { critImmune: true, statusImmune: true }
    },

    // TIER 8
    {
      id: 'weapons_platform',
      name: 'Weapons Platform',
      tier: 8,
      xpRequired: 875,
      description: 'Can fire twice per turn without penalty',
      effect: { doubleShotNoTurnEnd: true }
    },
    {
      id: 'walking_tank',
      name: 'Walking Tank',
      tier: 8,
      xpRequired: 875,
      description: 'Massive defensive boost. +50 Health, +40 Defense',
      effect: { health: 50, maxHealth: 50, defense: 40 }
    },

    // TIER 9
    {
      id: 'god_of_war',
      name: 'God of War',
      tier: 9,
      xpRequired: 1250,
      description: 'Ultimate destruction. +100% damage, +50 defense, unlimited suppression range',
      effect: { 
        weaponDamageBonus: 100, 
        defense: 50, 
        unlimitedSuppressionRange: true,
        explosiveDamageBonus: 100
      }
    }
  ],

  abilities: [
    {
      id: 'suppress_fire',
      name: 'Suppressing Fire',
      unlockAtXP: 0,
      cooldown: 1,
      description: 'Reduce enemy aim by 30 and pin them in place',
      usesPerMission: null
    },
    {
      id: 'holo_targeting',
      name: 'Holo-Targeting',
      unlockAtXP: 75,
      cooldown: 3,
      description: 'Mark target - all allies gain +20 aim against marked enemy',
      usesPerMission: null
    },
    {
      id: 'rocket_launcher',
      name: 'Rocket Launcher',
      unlockAtXP: 250,
      cooldown: 3,
      description: 'Fire explosive rocket at area, dealing massive AoE damage',
      usesPerMission: 2
    },
    {
      id: 'bunker_down',
      name: 'Bunker Down',
      unlockAtXP: 500,
      cooldown: 4,
      description: 'Become immobile but gain +60 defense and +50% damage for 3 turns',
      usesPerMission: 1
    },
    {
      id: 'saturation_fire',
      name: 'Saturation Fire',
      unlockAtXP: 1000,
      cooldown: 6,
      description: 'Unleash devastating barrage - hit all enemies in large area',
      usesPerMission: 1
    }
  ]
};